import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Eligible from './Eligible';
import { EligibleTest, getSimulationData } from 'services/store/features/Eligible/actions';
import { postCreateProject } from 'services/store/features/User/actions';
import type { AppDispatch, RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  simulation: {
    amountSought: state.eligible.amountSought,
    country: state.eligible.country,
    siren: state.eligible.siren,
    typeInvestment: state.eligible.typeInvestment,
    amountCA: state.eligible.amountCA,
    amountRN: state.eligible.amountRN,
  },
  user: {
    projectId: state.user.projectId,
    projectName: state.user.projectName,
    amountSought: state.user.amountSought,
  },
  successEligibleTest: state.eligible.successEligibleTest,
  invalidEligibleTest: state.eligible.invalidEligibleTest,
  successCreateProject: state.user.successCreateProject,
  alreadyUsed: state.user.alreadyUsed,
  status: state.eligible.status,
  auth: state.roles.status === 'SUCCEEDED',
  config: state.config,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({
    EligibleTest, getSimulationData, postCreateProject,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Eligible);
